export const FILTER_VISIBLE_PAGES = {
	searchPage: 'search-page',
	allPages: 'all',
};

export const FILTER_TYPES = {
	industryCategoryFilter: 'industryCategoryFilter',
	productTypeCategoryFilter: 'productTypeCategoryFilter',
	numericRangeFilter: 'numericRangeFilter',
	productReferenceFilter: 'productReferenceFilter',
	enumFilter: 'enumFilter',
};
